import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Select,
  FormControl,
  FormLabel,
  useToast,
  Text,
} from "@chakra-ui/react";
import { DateTime } from "luxon";

export const FilterMonthYearModal = ({ isOpen, onClose, data }: any) => {
  const navigate = useNavigate();

  const [selectedValue, setSelectedValue] = useState("");

  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");

  const generateMonthYearArray = () => {
    try {
      const startDate = DateTime.fromObject({
        month: 1,
        year: 2025,
      });
      const endDate = DateTime.now();
      let currentDate = startDate;
      const monthYearArray = [];
      let i = 0;

      while (currentDate <= endDate) {
        monthYearArray.push({
          month: currentDate.toFormat("MM"),
          year: currentDate.year,
          text: `${currentDate.toFormat("MMMM")}-${currentDate.year}`,
          index: i.toString(),
        });
        currentDate = currentDate.plus({ months: 1 });
        i++;
      }

      return monthYearArray;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleClose = () => {
    setSelectedValue("");
    setMonth("");
    setYear("");
    onClose();
  };

  const handleSubmit = async () => {
    const monthyearData = {
      month: month,
      year: year,
    };

    navigate("expertlist", { state: monthyearData });
  };

  const handleSelection = (value: any) => {
    setSelectedValue(value);

    const selectedMonth = generateMonthYearArray().find(
      (el) => el.index === value
    );

    if (selectedMonth) {
      setMonth(selectedMonth.month);
      setYear(selectedMonth.year.toString());
    }
  };

  //   useEffect(() => {
  //     handleSubmit();
  //   }, []);

  return (
    <>
      <Modal isOpen={isOpen} onClose={handleClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Select Month and Year</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <>
              <FormControl mt={4}>
                <FormLabel>Month</FormLabel>
                <Select
                  value={selectedValue}
                  onChange={(e) => handleSelection(e.target.value)}
                >
                  <option value="">Select Month</option>
                  {generateMonthYearArray().map((el) => (
                    <option value={el.index}>{el.text}</option>
                  ))}
                </Select>
              </FormControl>
            </>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
              Search
            </Button>
            <Button variant="ghost" onClick={handleClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
